import type { CcyCode } from './currencies.js';
import { D, MONEY_SCALE, type Money } from './decimal.js';

/**
 * Курсы конвертации в USDT — для USDT-превью прибыли в форме создания заявки.
 * Значения захардкожены в прототипе (recalc): RUB:83.98, CNY:7.13, USD:1, EUR:0.98, USDT:1, AED:3.66.
 * В рантайме сидятся в reference.usdt_rates и читаются API-эндпоинтом GET /ref/usdt-rates;
 * этот объект — fallback и источник для сидера.
 */
export const DEFAULT_USDT_RATES: Record<CcyCode, Money> = {
  USD: '1',
  EUR: '0.98',
  GBP: '0.79',
  USDT: '1',
  RUB: '83.98',
  CNY: '7.13',
  AED: '3.66',
};

/** value ÷ rate = USDT-эквивалент (по абсолютной величине), округление HALF_UP до MONEY_SCALE. */
export function toUsdt(amount: Money | number, ccy: CcyCode, rates: Record<CcyCode, Money> = DEFAULT_USDT_RATES): Money {
  const rate = rates[ccy] ?? '1';
  return D(amount).abs().dividedBy(D(rate)).toDecimalPlaces(MONEY_SCALE).toString();
}
